import { Instance } from "mobx-state-tree";
import { useProjectsRootStore } from "../../store/Hooks";
import { ProfileStore } from "./ProfileStore";

export const useProfileStore = (): Instance<typeof ProfileStore> => {
  return useProjectsRootStore().profileStore;
};
